import { useSubscription } from '@apollo/client/react'
import { AppointmentUpdatesSubscriptionDocument } from '@docpace/manager-graphql/dist/urql.types'
import { AppointmentUpdatesSubscriptionResultFragment } from '@docpace/manager-graphql'

export function useAppointmentUpdatesSubscription(opts: useSubscription.Options<AppointmentUpdatesSubscriptionResultFragment>){
    return useSubscription<AppointmentUpdatesSubscriptionResultFragment>(AppointmentUpdatesSubscriptionDocument, opts)
}